import { useEffect, useRef } from 'react';
import type { ConversationMessage } from '@cbm/types';
import { formatTime } from '../lib/time';

export function MessageList({
  messages,
  loading,
}: {
  messages: ConversationMessage[];
  loading: boolean;
}) {
  const endRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({
      block: 'end',
      behavior: 'smooth',
    });
  }, [messages, loading]);

  return (
    <div className="cbm-messages">
      {messages.map((message) => {
        const isVisitor = message.senderType === 'visitor';
        const label =
          message.senderType === 'human'
            ? 'Ομάδα'
            : message.senderType === 'ai'
              ? 'Βοηθός'
              : message.senderType === 'system'
                ? 'Σύστημα'
                : 'Εσείς';

        return (
          <div
            key={message.id}
            className={`cbm-message ${isVisitor ? 'cbm-message--visitor' : 'cbm-message--assistant'}`}
          >
            <div className="cbm-message__meta">
              <span>{label}</span>
              <span>{formatTime(message.createdAt)}</span>
            </div>
            <p>{message.content}</p>
          </div>
        );
      })}

      {loading ? (
        <div className="cbm-message cbm-message--assistant cbm-message--typing">
          <span />
          <span />
          <span />
        </div>
      ) : null}
      <div ref={endRef} />
    </div>
  );
}
